import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  TemplateRef,
  Input,
  ViewChild,
  OnDestroy
} from '@angular/core'
import { BsModalService } from 'ngx-bootstrap/modal'
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service'
import { CpmService } from '../../service/cpm.service'
import { DatePipe } from '@angular/common'
import { StoreService } from '../../service/store.service'
import { Subscription } from 'rxjs/Subscription'
import { FormControl } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'

@Component({
  selector: 'app-major-shareholder',
  templateUrl: './major-shareholder.component.html',
  styleUrls: ['./major-shareholder.component.scss']
})
export class MajorShareholderComponent implements OnInit, OnDestroy {
  @Input() companyProfile: any
  @Output() param = new EventEmitter()
  @Input() isFullFactSheet
  @Input() printPage
  IsMajorShare = true
  asOfList = []
  selectedMajorShareAsOf
  listOfMajor = null
  asOfControl = new FormControl()
  majorShareholderData = []
  majorShareholderAsofDataData = []
  majorData = []
  getMajordata = []
  textMajor
  lastName
  firstName
  newSearchInput = ''
  asDate = ''
  selectedMajorShareholderAsOfDate
  lastDate
  listOfPrint
  testDate = ['2018-04-23T17:00:00.000+0000']
  listMajor = []
  listChildMajor = []
  checkLengthList = false
  @ViewChild('template') template: TemplateRef<any>
  modalRef: BsModalRef
  subscription: Subscription
  majorShareDate
  listTop10FullFactSheet

  constructor(
    private modalService: BsModalService,
    private cpmService: CpmService,
    private datePipe: DatePipe,
    private store: StoreService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    const { majorShare } = this.activatedRoute.snapshot.params
    this.majorShareDate = majorShare
    this.subscription = this.store
      .getSecurityProfileNewResultObservable()
      .subscribe(response => {
        if (!response) {
          return
        }
        this.newSearchInput = response['securitySymbol']
        this.getMajorShareAsOfDate(this.newSearchInput)
      })

    this.asOfControl.valueChanges.debounceTime(100).subscribe(newValue => {
      if (!newValue) {
        return
      }
      if (this.majorShareDate !== undefined) {
        this.getMajorShareData(this.newSearchInput, this.majorShareDate)
      } else {
        this.getMajorShareData(this.newSearchInput, newValue)
      }
    })
  }
  getMajorShareAsOfDate(symbol) {
    this.cpmService.getMajorShareholderAsOfDateList(symbol).then(
      response => {
        this.asOfList = response
        const lastOfList = response.length < 1 ? '' : response[0]
        if (this.majorShareDate !== undefined) {
          this.selectedMajorShareAsOf = this.majorShareDate
        } else {
          this.selectedMajorShareAsOf = lastOfList
        }
      },
      err => { }
    )
  }

  getMajorShareData(symbol, date) {
    this.listMajor = []
    this.listChildMajor = []
    this.listTop10FullFactSheet = []
    date = this.datePipe.transform(date, 'yyyy-MM-dd')
    this.cpmService.getMajorShareholder(symbol, date).then(
      response => {
        this.listOfMajor = []
        this.listOfMajor = response
        this.listOfMajor.length === 10 ? this.checkLengthList = true : this.checkLengthList = false
        this.listOfPrint = response
        this.listOfMajor.map((marjor, i) => {
          i < 10
            ? this.listMajor.push(marjor)
            : this.listChildMajor.push(marjor)
        })
        this.listOfPrint.map((top10, i) => {
          if (i <= 9) {
            top10['num'] = i + 1
            this.listTop10FullFactSheet.push(top10)
          }
        })

        if (this.listMajor.length > 0) {
          const size = this.listMajor.length - 1
          const major = this.listMajor[size]
          major['list'] = this.listChildMajor
          this.listMajor.push(major)
        }
      },
      err => { }
    )
  }

  onClickOpenModal(firstName, lastName) {
    this.lastName = lastName
    this.firstName = firstName
    this.openModal(this.template)
  }
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'modal-lg' })
    )
  }
  closeModal() {
    this.modalRef.hide()
  }

  isClassLabel(id) {
    return id < 10
  }

  changedEvent(event) {
    $(event.target)
      .parents()
      .next('.hide')
      .toggle()
  }
  checkTop10Text() {
    this.isFullFactSheet === true
      ? (this.textMajor = 'Top 10 Major shareholder')
      : (this.textMajor = 'Major shareholder')
    return this.textMajor
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/major-shareholder/major-shareholder.component.ts